import React, { useEffect } from "react";

const AdsenseComponent = () => {
  useEffect(() => {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  return (
    <div>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={process.env.REACT_APP_DATA_AD_CLIENT}
        data-ad-slot={process.env.REACT_APP_DATA_AD_SLOT}
        data-ad-format="auto"
      ></ins>
    </div>
  );
};

export default AdsenseComponent;
